<template>
<div>
  <v-layout row justify-end style="max-width:992px;margin: 0 auto;">
    <v-dialog v-model="addEventDialog" max-width="600px" v-if="$route.name !== 'home'">
      <v-btn flat slot="activator" color="green lighten-2" light>
        <v-icon class="mr-1" small>add_box</v-icon> Add Event</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Add Event</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-validate="'required'" :error-messages="errors.collect('title')" data-vv-name="title" color="green" placeholder="Event Title" v-model="title"></v-text-field>
            <markdown-editor class="text-xs-left" color="green" v-model="description" :configs="configs" required />
            <v-text-field label="Start time" v-validate="'required'" :error-messages="errors.collect('startDate')" data-vv-name="startDate" color="green" type="datetime-local" name="startDate" v-model="startDate" />
            <v-text-field label="End time" v-validate="'required'" :error-messages="errors.collect('endDate')" data-vv-name="endDate" color="green" type="datetime-local" name="endDate" v-model="endDate" />
            <v-switch color="green" label="All Day" v-model="allDay"></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="green lighten-2" light @click="addEventDialog = false">Cancel</v-btn>
          <v-btn flat color="green lighten-2" light @click="addEventTime">Add Event</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout justify-end v-else>
      <v-btn flat slot="activator" color="green lighten-2" :to="{ name: 'calendar' }" light>Calendar</v-btn>
    </v-layout>
  </v-layout>
  <v-layout row style="max-width:992px;margin: 0 auto;">
    <v-flex md12 v-if="$route.name !== 'calendar'">
      <div class="single-day-container-home">
        <div class="day-container">
          <div class="day-info">
            <div :key="month" class="month-name">{{ month }}</div>
            <div class="day-number">{{ selectedDay.number }}</div>
            <div class="day-name">{{ selectedDay.name }}</div>
          </div>
          <div class="day-data">
          </div>
        </div>
        <div class="event-container">
          <ul class="event-list">
            <li v-if="selectedDay.number && !dayEvents.length" class="mt-2 event-list-item">No events found</li>
            <li class="mt-2 event-list-item" :class="{ 'active': dayEvent.isActive }" v-for="(dayEvent, index) in dayEvents" :key="`dayEvent-${index}`">
              <div class="event-dates" v-if="!dayEvent.allDay">
                <span>{{ dayEvent.startDate | getTime }}</span>
                <span>{{ dayEvent.endDate | getTime }}</span>
              </div>
              <div class="event-dates" v-else>
                <span>All Day</span>
              </div>
              <div class="event-details">
                <div class="truncate">{{ dayEvent.title }}</div>
                <v-btn icon color="green darken-2" class="white--text" small @click.stop="$set(dialogNote, dayEvent.startDate, true)">
                  <v-icon small>open_in_new</v-icon>
                </v-btn>
              </div>
              <v-dialog v-model="dialogNote[dayEvent.startDate]" scrollable lazy max-width="500" :key="dayEvent.startDate">
                <v-card light>
                  <v-card-title class="green white--text">
                    <div class="day-container">
                      <div class="day-info">
                        <div class="day-number">{{ selectedDay.number }}</div>
                        <div class="day-name">{{ selectedDay.name }}</div>
                      </div>
                      <div class="day-data">
                      </div>
                    </div>
                    <div class="ml-4 event-dates" v-if="!dayEvent.allDay">
                      <span>{{ dayEvent.startDate | getTime }}</span> -
                      <span>{{ dayEvent.endDate | getTime }}</span>
                    </div>
                    <div class="ml-4 event-dates" v-else>
                      <span>All Day</span>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div class="text-xs-left event-details">
                      <h3>{{ dayEvent.title }}</h3>
                      <vue-markdown :source="dayEvent.description"></vue-markdown>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click.stop="$set(dialogNote, dayEvent.startDate, false)">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </div>
      </div>
    </v-flex>
    <v-flex md4 order-sm2 v-if="$route.name !== 'home'">
      <div class="single-day-container">
        <div class="day-container">
          <div class="day-info">
            <div class="day-number">{{ selectedDay.number }}</div>
            <div class="day-name">{{ selectedDay.name }}</div>
          </div>
          <div class="day-data">
          </div>
        </div>
        <div class="event-container">
          <ul class="event-list">
            <li v-if="selectedDay.number && !dayEvents.length" class="mt-2 event-list-item">No events found</li>
            <li class="mt-2 event-list-item" :class="{ 'active': dayEvent.isActive }" v-for="(dayEvent, index) in dayEvents" :key="`dayEvent-${index}`">
              <div class="event-dates" v-if="!dayEvent.allDay">
                <span>{{ dayEvent.startDate | getTime }}</span>
                <span>{{ dayEvent.endDate | getTime }}</span>
              </div>
              <div class="event-dates" v-else>
                <span>All Day</span>
              </div>
              <div class="event-details">
                <div class="truncate">{{ dayEvent.title }}</div>
                <v-btn icon color="green darken-2" class="white--text" small @click.stop="$set(dialogNote, dayEvent.startDate, true)">
                  <v-icon small>open_in_new</v-icon>
                </v-btn>
              </div>
              <v-dialog v-model="dialogNote[dayEvent.startDate]" scrollable lazy max-width="500" :key="dayEvent.startDate">
                <v-card light>
                  <v-card-title class="green white--text">
                    <div class="day-container">
                      <div class="day-info">
                        <div class="day-number">{{ selectedDay.number }}</div>
                        <div class="day-name">{{ selectedDay.name }}</div>
                      </div>
                      <div class="day-data">
                      </div>
                    </div>
                    <div class="ml-4 event-dates" v-if="!dayEvent.allDay">
                      <span>{{ dayEvent.startDate | getTime }}</span> -
                      <span>{{ dayEvent.endDate | getTime }}</span>
                    </div>
                    <div class="ml-4 event-dates" v-else>
                      <span>All Day</span>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div class="text-xs-left event-details">
                      <h3>{{ dayEvent.title }}</h3>
                      <vue-markdown :source="dayEvent.description"></vue-markdown>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click.stop="$set(dialogNote, dayEvent.startDate, false)">Close</v-btn>
                    <v-btn small color="grey lighten-1" fab flat @click="removeEvent = true">
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <v-dialog v-model="removeEvent" max-width="500" light>
                      <v-card>
                        <v-card-title>
                          <span class="headline">Delete Event</span>
                        </v-card-title>
                        <v-card-text>
                          <p>Are you sure you want to permanently delete this event?</p>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="green lighten-2" flat @click="removeEvent = false">
                            Cancel
                          </v-btn>
                          <v-btn color="red" outline @click="deleteEvent(dayEvent.id)">
                            Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </div>
      </div>
    </v-flex>
    <v-flex md8 order-sm1 v-if="$route.name !== 'home'">
      <div class="calendar-container">
        <div class="calendar">
          <div class="header row flex-middle">
            <div class="col col-start">
              <v-icon light @click="prevMonth">chevron_left</v-icon>
            </div>
            <div class="col col-center">
              <transition tag="div" :name="typeTransition">
                <div :key="month" class="month-name">{{ month }}</div>
              </transition>
            </div>
            <div class="col col-end">
              <v-icon light @click="nextMonth">chevron_right</v-icon>
            </div>
          </div>
          <div class="days row">
            <div class="col col-center" v-for="(day, index) in dayNames" :key="`h-${index}`">
              <div class="day-name">{{ day }}</div>
            </div>
          </div>
          <div class="body grey--text text--darken-2">
            <div class="row" v-for="(row, index) in rows" :key="`r-${index}`">
              <div class="col cell" :class="[{'has-events': day.hasEvents}, day.type]" v-for="(day, index) in row.days" :key="`d-${index}`" @click="updateDate(day)">
                <transition-group tag="div" :name="typeTransition">
                  <div :key="day.formattedDate" class="day-number">{{ day.formattedDate }}</div>
                </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</div>
</template>
<script>
import editorOptions from '@/scripts/editor-options'
import VueMarkdown from 'vue-markdown'
import firebase, {
  db
} from "@/firebaseConfig";
export default {
  name: "Calendar",
  components: {
    VueMarkdown
  },
  data() {
    return {
      currentMonth: new Date(),
      selectedDate: new Date(),
      events: [],
      dialogNote: {},
      title: "",
      description: "",
      startDate: "",
      endDate: "",
      allDay: false,
      removeEvent: false,
      addEventDialog: false,
      showEventDialog: false,
      transitionDirection: "",
      editorOptions,
      dictionary: {
        custom: {
          title: {
            required: () => 'Title can not be empty',
            // custom messages
          },
          startDate: {
            required: () => 'Start Date can not be empty',
            // custom messages
          },
          endDate: {
            required: () => 'End Date can not be empty',
            // custom messages
          }
        }
      },
      currentPage: {
        month: dateFns.getMonth(new Date()),
        year: dateFns.getYear(new Date())
      },
      configs: {
        toolbar: ['bold', 'italic', 'heading', '|', 'ordered-list', 'unordered-list', '|', 'quote', 'horizontal-rule', '|', 'link', 'image', 'code']
      }
    };
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    loadGroupEvents() {
      this.$bind(
        "events",
        db
        .collection("projects")
        .doc(this.$route.params.groupID)
        .collection('events')
        .orderBy('startDate')
      ).then(events => {
        this.events === events;
      });
    },
    addEventTime() {
      this.$validator.validateAll()
      if (this.title !== "") {
        db.collection("projects")
          .doc(this.$route.params.groupID)
          .collection("events")
          .add({
            startDate: this.startDate,
            endDate: this.endDate,
            allDay: this.allDay,
            title: this.title,
            description: this.description
          })
          .then(() => {
            this.startDate = ""
            this.endDate = ""
            this.allDay = false
            this.title = ""
            this.description = ""
            this.addEventDialog = false
          });
      }
    },
    deleteEvent(id) {
      db.collection("projects").doc(this.$route.params.groupID).collection('events').doc(id).delete()
      this.removeEvent = false
      this.showEventDialog = false
    },
    nextMonth() {
      this.currentMonth = dateFns.addMonths(this.currentMonth, 1);
      this.updateCurrentPage(this.currentMonth);
    },

    prevMonth() {
      this.currentMonth = dateFns.subMonths(this.currentMonth, 1);
      this.updateCurrentPage(this.currentMonth);
    },

    updateDate(day) {
      this.selectedDate = day.day;
    },

    updateCurrentPage(date) {
      this.currentPage = {
        month: dateFns.getMonth(date),
        year: dateFns.getYear(date)
      };
    },

    findEvents(day, sort = false) {
      let hasEvents = this.events.reduce((list, ev) => {
        if (dateFns.isSameDay(day, new Date(ev.startDate))) {
          ev.isActive =
            ev.allDay ||
            dateFns.isWithinRange(
              new Date(),
              new Date(ev.startDate),
              new Date(ev.endDate)
            );
          list.push(ev);
        }
        return list;
      }, []);
      if (sort) {
        hasEvents.sort((a, b) => {
          const dateA = new Date(a.startDate);
          const dateB = new Date(b.startDate);
          return dateFns.compareAsc(dateA, dateB);
        });
      }
      return hasEvents;
    },

    getTransitionDirection(fromPage, toPage) {
      if (!fromPage || !toPage) return "";
      if (fromPage.year !== toPage.year)
        return fromPage.year < toPage.year ? "next" : "prev";
      if (fromPage.month !== toPage.month)
        return fromPage.month < toPage.month ? "next" : "prev";
      return "";
    }
  },
  computed: {
    selectedDay() {
      return {
        number: dateFns.format(this.selectedDate, "D"),
        name: dateFns.format(this.selectedDate, "dddd")
      };
    },

    month() {
      const dateFormat = "MMMM YYYY";
      return dateFns.format(this.currentMonth, dateFormat);
    },

    dayNames() {
      const dateFormat = "ddd";
      let startDate = dateFns.startOfISOWeek(this.currentMonth);

      const days = [];
      for (let i = 0; i < 7; i += 1) {
        days.push(dateFns.format(dateFns.addDays(startDate, i), dateFormat));
      }
      return days;
    },

    rows() {
      const monthStart = dateFns.startOfMonth(this.currentMonth);
      const monthEnd = dateFns.endOfMonth(monthStart);
      const startDate = dateFns.startOfISOWeek(monthStart);
      const endDate = dateFns.endOfISOWeek(monthEnd);

      const dateFormat = "D";
      const rows = [];

      let days = [];
      let day = startDate;
      let formattedDate = "";

      while (day <= endDate) {
        for (let i = 0; i < 7; i += 1) {
          formattedDate = dateFns.format(day, dateFormat);
          const dayInfo = {
            day,
            formattedDate,
            type: !dateFns.isSameMonth(day, monthStart) ?
              "disabled" : dateFns.isSameDay(day, this.selectedDate) ? "selected" : "",
            hasEvents: this.findEvents(day).length > 0
          };
          days.push(dayInfo);
          day = dateFns.addDays(day, 1);
        }
        rows.push({
          days: days
        });
        days = [];
      }
      return rows;
    },
    dayEvents() {
      return this.findEvents(this.selectedDate, true);
    },

    typeTransition() {
      return `${
        this.transitionDirection === "next" ? "slide-left" : "slide-right"
      }`;
    }
  },
  filters: {
    getTime(value) {
      const dateFormat = "h:mm A";
      return dateFns.format(value, dateFormat);
    }
  },
  created() {
    this.loadGroupEvents();
  },
  watch: {
    currentPage(val, oldVal) {
      this.transitionDirection = this.getTransitionDirection(oldVal, val);
    },
    "$route.params.groupID" (id) {
      this.loadGroupEvents();
    }
  },
};
</script>

<style lang="scss" scoped>
$main-color: #388E3C;
$text-color: #4c4c4c;
$text-color-light: #cccccc;
$bg-color: #a1eec4;
$hover-color: #f7f7f7;
$neutral-color: #ffffff;

.row {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
}

.col {
    flex-grow: 1;
    flex-basis: 0;
    max-width: 100%;
}

.col-start {
    justify-content: flex-start;
    text-align: left;
}

.col-center {
    justify-content: center;
    text-align: center;
}

.col-end {
    justify-content: flex-end;
    text-align: right;
}

/* Wrapper */

.container {

    .single-day-container {
        background-color: $main-color;
        padding: 3rem;
        min-height: 600px;
        max-height: 630px;
        overflow-y: auto;
        @media (max-width: 640px) {
            min-height: 230px;
            max-height: 230px;
        }
    }

    .single-day-container-home {
        background-color: $main-color;
        padding: 3rem;
        overflow-y: auto;
    }

    .calendar-container {
        background-color: $neutral-color;
        padding: 3rem;
        min-height: 600px;
    }
}

/* Calendar */
.calendar {
    display: block;
    position: relative;
    width: 100%;
    background: $neutral-color;

    .header {
        text-transform: capitalize;
        font-weight: 400;
        font-size: 120%;
        padding: 1.5em 0;
        align-items: center;

        .icon {
            cursor: pointer;
            user-select: none;
            transition: 0.15s ease-out;
            &:hover {
                transform: scale(1.75);
                transition: 0.25s ease-out;
                color: $main-color;
            }
            &:first-of-type {
                margin-left: 2rem;
            }
            &:last-of-type {
                margin-right: 2rem;
            }
        }

        .col {
            flex-shrink: 1;
            flex-basis: auto;
        }

        .month-name {
            font-size: 2rem;
            color: $main-color;
        }
    }

    .days {
        text-transform: uppercase;
        font-weight: 700;
        color: $main-color;
        padding: 0.75rem 0;

        .col {
            padding: 0 1rem;
        }

        .day-name {
            padding: 0.25rem 0;
            @media (max-width: 640px) {
                display: none;
            }
        }

        & .selected {
            .day-name {
                font-weight: 700;
                border-bottom: 2px solid $main-color;
            }
        }
    }

    .body {
        .cell {
            position: relative;
            background: $neutral-color;
            padding: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            :last-child {
                border-right: none;
            }

            &.has-events {
                &:after {
                    position: absolute;
                    content: '';
                    width: 0.75rem;
                    height: 0.75rem;
                    background-color: $main-color;
                    top: 8px;
                    right: 23px;
                    border-radius: 0.5rem;
                    border: 3px solid $neutral-color;
                }
            }

            .day-number {
                line-height: 1;
                font-weight: 700;
                padding: 0.75rem;
                text-align: center;
                cursor: pointer;
                border-radius: 0.25rem;
                &:hover {
                    background: $hover-color;
                }
            }
        }

        .col {
            flex-grow: 0;
            flex-basis: (100% / 7);
            width: (100% / 7);
        }

        .selected {
            & .day-number {
                background-color: $main-color;
                color: $neutral-color;
                &:hover {
                    background-color: $main-color;
                    color: $neutral-color;
                }
            }
        }

        .disabled {
            color: $text-color-light;
            pointer-events: none;
        }
    }
}

.day-container {
    display: flex;
    flex-direction: row;
    padding-bottom: 1rem;
    border-bottom: 2px solid $neutral-color;

    .day-info {
        color: $neutral-color;
        flex: 5;
        text-align: left;
        font-weight: 400;

        .day-number {
            font-size: 4rem;
            line-height: 1;
        }
    }

    .day-data {
        flex: 2;
    }
}

.event-container {
    .event-list {
        padding: 0;
        color: $neutral-color;
        font-size: 14px;

        .event-list-item {
            list-style: none;
            display: flex;
            flex-direction: row;
            margin-bottom: 0.75rem;
            align-items: center;
            position: relative;
            &:last-child {
                margin-bottom: 0;
            }

            .event-dates {
                min-width: 60px;

                span {
                    text-align: right;
                    display: block;
                }
            }

            .event-details {
                margin-left: 0.75rem;
                background-color: rgba($neutral-color, 0.2);
                flex: 1;
                padding: 0.5rem;
                border-radius: 0.25rem;
            }

            &.active {
                .event-details {
                    background-color: rgba($neutral-color, 0.4);
                }
            }
        }
    }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    transition: all 0.25s ease-in-out;
}

.slide-left-leave-active,
.slide-right-leave-active {
    position: absolute;
}

.slide-left-enter,
.slide-right-leave-to {
    opacity: 0;
    transform: translateX(50px) translateZ(0);
}

.slide-left-leave-to,
.slide-right-enter {
    opacity: 0;
    transform: translateX(-50px) translateZ(0);
}
.calendar .body .col:nth-last-child(-n+2) {
    background: #f2f2f2;
}
.truncate {
    width: 113px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/Calendar.vue